import { integer, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getMonetaryField,
  getPreciseMonetaryField,
  typedJsonb,
} from '../common/utils'

export const productTypeEnum = pgEnum('product_type', ['material', 'labor'])

export const products = pgTable(
  'products',
  {
    ...getBaseFields(),
    type: productTypeEnum().notNull().default('material'),
    name: text().notNull(),
    description: text(),
    supplier: text(),
    supplierCode: text(),
    productNumber: text(),
    unit: text(),
    discountGroup: text(),
    internalSupplierListPriceVat0: getMonetaryField(),
    internalPurchasePriceVat0: getMonetaryField(),
    unitPriceVat0: getPreciseMonetaryField(),
    defaultMarkupPercent: integer().default(20),
    // Sales-facing content (snapshotted into offers when added to a price box)
    salesIncludedItems: typedJsonb<string[]>('sales_included_items')
      .notNull()
      .default([]),
    salesPrerequisites: typedJsonb<string[]>('sales_prerequisites')
      .notNull()
      .default([]),
    salesExclusions: typedJsonb<string[]>('sales_exclusions')
      .notNull()
      .default([]),
  },
  (table) => ({
    ...getBaseIndexes('products', table),
    // Unique index on (supplier, product_number, COALESCE(supplier_code, ''))
    // Custom SQL in migration — Drizzle can't express COALESCE in indexes
  }),
)
